var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('sub-header',{attrs:{"menuList":_vm.menuList}}),_c('sub-body'),_c('sub-footer',{attrs:{"mainViewIdList":_vm.mainViewIdList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }